export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/chevrons.ecc17b4f.svg","height":40,"width":58,"blurWidth":0,"blurHeight":0};